import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { setTimeout } from "timers";
import * as FileSaver from 'file-saver';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';


class UpdateOtherCoverage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldSendData: true,
            showLoader: false,
            otherCoverage: props.location.state ? props.location.state.otherCoverage : null,
            isUpdate: props.location.state ? true : false,
            firstName: null,
            lastName: null,
            gender: null,
            birthDate: null,
            relationToSubscriber: null,
            companyName: null,
            phoneNumber: null,
            extension: null,
            address: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            planName: null,
            policyType: null,
            mbi: null,
            coverageType: null,
            groupNumber: null,
            alternatePolicyNumber: null,
            priority: null,
            startDate: null,
            isCourtOrdered: false,
            isRetiree: false,
            showValidationError: false,
            validationError: ""
        };
        this.initializeDropdowns = this.initializeDropdowns.bind(this);
        this.initializeFieldsForEdit = this.initializeFieldsForEdit.bind(this);
        this.getFormattedDate = this.getFormattedDate.bind(this);
        this.submitOtherCoverageRequest = this.submitOtherCoverageRequest.bind(this);
        this.validateInputFields = this.validateInputFields.bind(this);
        this.goToOtherCoveragePage = this.goToOtherCoveragePage.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.OtherCoverage.ComponentDidMount", new Date(), Tools.getURLPath());

        if (this.state.otherCoverage) {
            this.initializeFieldsForEdit();
        }
        this.initializeDropdowns(false);
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.otherCoverageRequestNumber !== prevProps.otherCoverageRequestNumber || this.props.error !== prevProps.error) {
            this.setState({ showLoader: false, shouldSendData: false });
        }
    }

    initializeFieldsForEdit() {
        this.setState({
            firstName: this.state.otherCoverage.subscriberName.split(" ")[0],
            lastName: this.state.otherCoverage.subscriberName.split(" ")[1],
            gender: this.state.otherCoverage.subscriberGenderCode,
            birthDate: this.getFormattedDate(this.state.otherCoverage.subscriberBirthDate),
            relationToSubscriber: this.state.otherCoverage.relationToSubscriber,
            companyName: this.state.otherCoverage.companyName,
            phoneNumber: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.telephones[0] ? this.state.otherCoverage.companyAddress.telephones[0].areaCode + this.state.otherCoverage.companyAddress.telephones[0].number : null : null,
            extension: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.telephones[0] ? this.state.otherCoverage.companyAddress.telephones[0].extension : null : null,
            address: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.addressLine1 : null,
            address2: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.addressLine2: null,
            city: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.city : null,
            state: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.state : null,
            zip: this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.zipCode : null,
            planName: this.state.otherCoverage.benefitPlanName,
            policyType: this.state.otherCoverage.policyType !== "Non-Medicare" ? "Medicare" : "Non-Medicare",
            mbi: this.state.otherCoverage.mbi,
            coverageType: this.state.otherCoverage.coverageType,
            groupNumber: this.state.otherCoverage.groupNumber,
            alternatePolicyNumber: this.state.otherCoverage.alternatePolicyNumber,
            priority: this.state.otherCoverage.priority,
            startDate: this.getFormattedDate(this.state.otherCoverage.startDate),
            isCourtOrdered: this.state.otherCoverage.isCourtOrdered,
            isRetiree: this.state.otherCoverage.isRetiree
        });
    }

    initializeDropdowns() {
        var genderDropdown = document.getElementById("update-coverage-gender-dropdown");
        var rltpToSubscriberDropdown = document.getElementById("update-coverage-relation-dropdown");
        var stateDropdown = document.getElementById("update-coverage-state-dropdown");
        var policyTypeDropdown = document.getElementById("update-coverage-policy-type-dropdown");
        var coverageTypeDropdown = document.getElementById("update-coverage-coverage-type-dropdown");
        var priorityDropdown = document.getElementById("update-coverage-priority-dropdown");

        genderOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[1];
            optionHTML.value = option[0];
            genderDropdown.add(optionHTML, genderDropdown[0]);
        });

        rltpToSubscriberOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[1];
            optionHTML.value = option[0];
            rltpToSubscriberDropdown.add(optionHTML, rltpToSubscriberDropdown[0]);
        });

        stateOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[0];
            optionHTML.value = option[1];
            stateDropdown.add(optionHTML, stateDropdown[0]);
        });

        policyTypeOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[1];
            optionHTML.value = option[0];
            policyTypeDropdown.add(optionHTML, policyTypeDropdown[0]);
        });

        coverageTypeOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[1];
            optionHTML.value = option[0];
            coverageTypeDropdown.add(optionHTML, coverageTypeDropdown[0]);
        });

        priorityOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[1];
            optionHTML.value = option[0];
            priorityDropdown.add(optionHTML, priorityDropdown[0]);
        });

        if (this.state.otherCoverage) {
            this.state.otherCoverage.gender ? genderDropdown.value = this.state.otherCoverage.gender : genderDropdown.selectedIndex = -1;
            this.state.otherCoverage.relationToSubscriber ? rltpToSubscriberDropdown.value = this.state.otherCoverage.relationToSubscriber : rltpToSubscriberDropdown.selectedIndex = -1;
            this.state.otherCoverage.state ? stateDropdown.value = this.state.otherCoverage.state : stateDropdown.selectedIndex = -1;
            this.state.otherCoverage.policyType ? policyTypeDropdown.value = this.state.otherCoverage.policyType == "Non-Medicare" ? "Non-Medicare" : "Medicare" : policyTypeDropdown.selectedIndex = -1;
            this.state.otherCoverage.coverageType ? coverageTypeDropdown.value = this.state.otherCoverage.coverageType : coverageTypeDropdown.selectedIndex = -1;
            this.state.otherCoverage.priority ? priorityDropdown.value = this.state.otherCoverage.priority : priorityDropdown.selectedIndex = -1;
        } else {
            genderDropdown.selectedIndex = -1;
            rltpToSubscriberDropdown.selectedIndex = -1;
            stateDropdown.selectedIndex = -1;
            policyTypeDropdown.selectedIndex = -1;
            coverageTypeDropdown.selectedIndex = -1;
            priorityDropdown.selectedIndex = -1;
        }
    }

    getFormattedDate(dateString) {
        if (dateString) {
            var date = new Date(dateString);
            return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
        }
        return "";
    }

    submitOtherCoverageRequest() {
        if (this.validateInputFields()) {
            this.setState({ showLoader: true });
            this.props.updateOtherCoverage(this.state.firstName + " " + this.state.lastName,
                this.state.birthDate,
                this.state.gender,
                this.state.relationToSubscriber,
                this.state.policyType,
                this.state.mbi,
                this.state.coverageType,
                this.state.planName,
                this.state.alternatePolicyNumber,
                this.state.groupName,
                this.state.groupNumber,
                this.state.priority,
                this.state.isCourtOrdered,
                this.state.isRetiree,
                this.state.companyName,
                this.state.address,
                this.state.address2,
                this.state.city,
                this.state.state,
                this.state.zip,
                this.state.phoneNumber ? this.state.phoneNumber.length > 3 ? this.state.phoneNumber.substring(0, 3) : null : null,
                this.state.phoneNumber,
                this.state.extension,
                this.state.startDate,
                this.state.isUpdate ? this.state.otherCoverage.policySystemId : null);
        }
    }

    validateInputFields() {
        var isValid = true;
        var isAddressValid = true;
        var isPhoneNumberValid = true;
        var missingFields = [];
        this.setState({ showValidationError: false, validationError: "" });

        if (!this.state.firstName || this.state.firstName == "") {
            isValid = false;
            missingFields.push("First Name");
        }
        if (!this.state.lastName || this.state.lastName == "") {
            isValid = false;
            missingFields.push("Last Name");
        }
        if (!this.state.relationToSubscriber || this.state.relationToSubscriber == "") {
            isValid = false;
            missingFields.push("Relation to Subscriber");
        }
        if (!this.state.companyName || this.state.companyName == "") {
            isValid = false;
            missingFields.push("Company Name");
        }
        if (!this.state.planName || this.state.planName == "") {
            isValid = false;
            missingFields.push("Benefit Plan Name");
        }
        if (!this.state.policyType || this.state.policyType == "") {
            isValid = false;
            missingFields.push("Policy Type");
        }
        if (this.state.policyType != "Non-Medicare" && (!this.state.mbi || this.state.mbi == "")){
            isValid = false;
            missingFields.push("MBI");
        }
        if (!this.state.coverageType || this.state.coverageType == "") {
            isValid = false;
            missingFields.push("Coverage Type");
        }
        if (!this.state.alternatePolicyNumber || this.state.alternatePolicyNumber == "") {
            isValid = false;
            missingFields.push("Alternate Policy Number");
        }
        if (!this.state.groupNumber || this.state.groupNumber == "") {
            isValid = false;
            missingFields.push("Group Number");
        }
        if (!this.state.startDate || this.state.startDate == "") {
            isValid = false;
            missingFields.push("Effective Date");
        }
        if (this.state.address || this.state.city || this.state.state || this.state.zip) {
            if (!(this.state.address && this.state.city && this.state.state && this.state.zip)) {
                isAddressValid = false;
                isValid = false;
            }
        }
        if (this.state.phoneNumber && !this.state.phoneNumber.match(/^\d{10}$/)) {
            isPhoneNumberValid = false;
            isValid = false;
        }

        if (!isValid) {
            var validationError = "";

            if (missingFields.length > 0) {
                validationError = "Please fill required fields: ";
                missingFields.forEach((fieldName) => { validationError = validationError + fieldName + ", " });
                validationError = validationError.substring(0, validationError.length - 2);
            }
            if (!isAddressValid) {
                validationError = validationError == "" ? "Please be sure to fill all Address fields, or none: Address, City, State, Zip Code." : validationError + ". Also be sure to fill all Address fields, or none: Address, City, State, Zip Code.";
            }
            if (!isPhoneNumberValid) {
                validationError = validationError == "" ? "Please be sure to enter a 10 digit phone number." : validationError + ". Also be sure to enter a 10 digit phone number.";
            }


            this.setState({ showValidationError: true, validationError: validationError });
        } 

        return isValid && isAddressValid && isPhoneNumberValid;
    }

    goToOtherCoveragePage() {
        this.props.history.push('/otherCoverage');
    }

    handleDayPickerFocusChange(isFocused, labelId) {
        var floatingLabel = document.getElementById(labelId);
        if (floatingLabel) {
            if (isFocused) {
                floatingLabel.classList.add("float-upper-left");
            } else if (floatingLabel.value) {
                floatingLabel.classList.add("float-upper-left");
            } else {
                floatingLabel.classList.remove("float-upper-left");
            }
        }
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="update-other-coverage-wrapper">
                            {this.state.showLoader ?
                                <div id="other-coverage-spinner" className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                :
                                this.state.shouldSendData || (!this.props.otherCoverageRequestNumber && !this.props.error) ?
                                <div className="update-other-coverage-container">
                                    <div className="hp-title">{this.state.otherCoverage ? "Edit Other Coverage" : "Add Other Coverage"}</div>
                                    <div className="row update-coverage-group">
                                        <div className="col-12 bold-text update-coverage-header">
                                            <span>PolicyHolder</span>
                                        </div>
                                        <div className="col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.firstName || ""} onChange={(e) => { this.setState({ firstName: e.target.value }) }} />
                                            <span className="floating-label">First Name</span>
                                        </div>
                                        <div className="col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.lastName || ""} onChange={(e) => { this.setState({ lastName: e.target.value }) }} />
                                            <span className="floating-label">Last Name</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-gender-dropdown" onChange={(e) => { this.setState({ gender: e.target.value }) }}></select>
                                            <span className="floating-label">Gender(Optional)</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field update-coverage-day-picker">
                                            <DayPickerInput
                                                inputProps={
                                                    { required: true }
                                                } 
                                                value={this.state.birthDate || ""}
                                                placeholder="Birth Date(Optional)"
                                                formatDate={formatDate}
                                                parseDate={parseDate}
                                                onDayChange={(value) => this.setState({ birthDate: value })}>
                                            </DayPickerInput>
                                            <div className="icon-calendar-form calendar-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-relation-dropdown" onChange={(e) => { this.setState({ relationToSubscriber: e.target.value }) }}></select>
                                            <span className="floating-label">Relation to Subscriber</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                    </div>
                                    <div className="row update-coverage-group">
                                        <div className="col-12 bold-text update-coverage-header">
                                            <span>Insurance Company</span>
                                        </div>
                                        <div className="col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.companyName || ""} onChange={(e) => { this.setState({ companyName: e.target.value }) }} />
                                            <span className="floating-label">Company Name</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.phoneNumber || ""} onChange={(e) => { this.setState({ phoneNumber: e.target.value.replace(/\D/g, '') }) }} />
                                            <span className="floating-label">Phone Number(Optional)</span>
                                        </div>
                                        <div className="col-lg-2 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.extension || ""} onChange={(e) => { this.setState({ extension: e.target.value }) }} />
                                            <span className="floating-label">EXT</span>
                                        </div>
                                        <div className="col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.address || ""} onChange={(e) => { this.setState({ address: e.target.value }) }} />
                                            <span className="floating-label">Address(Optional)</span>
                                        </div>
                                        <div className="col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.address2 || ""} onChange={(e) => { this.setState({ address2: e.target.value }) }} />
                                            <span className="floating-label">Address 2(Optional)</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.city || ""} onChange={(e) => { this.setState({ city: e.target.value }) }} />
                                            <span className="floating-label">City(Optional)</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-state-dropdown" onChange={(e) => { this.setState({ state: e.target.value }) }}></select>
                                            <span className="floating-label">State(Optional)</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.zip || ""} onChange={(e) => { this.setState({ zip: e.target.value }) }} />
                                            <span className="floating-label">Zip Code(Optional)</span>
                                        </div>
                                    </div>
                                    <div className="row update-coverage-group">
                                        <div className="col-12 bold-text update-coverage-header">
                                            <span>Policy Details</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.planName || ""} onChange={(e) => { this.setState({ planName: e.target.value }) }} />
                                            <span className="floating-label">Plan Name</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-policy-type-dropdown" onChange={(e) => { this.setState({ policyType: e.target.value }) }}></select>
                                            <span className="floating-label">Policy Type</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                        <div className={`col-lg-4 col-md-6 col-sm-12 coverage-input-field ${this.state.policyType != "Non-Medicare" ? "" : "hidden"}`}>
                                            <input required type="text" className="text-input" value={this.state.mbi || ""} onChange={(e) => { this.setState({ mbi: e.target.value }) }} />
                                            <span className="floating-label">MBI</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-coverage-type-dropdown" onChange={(e) => { this.setState({ coverageType: e.target.value }) }}></select>
                                            <span className="floating-label">Coverage Type</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.groupNumber || ""} onChange={(e) => { this.setState({ groupNumber: e.target.value }) }} />
                                            <span className="floating-label">Group Number</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <input required type="text" className="text-input" value={this.state.alternatePolicyNumber || ""} onChange={(e) => { this.setState({ alternatePolicyNumber: e.target.value }) }} />
                                            <span className="floating-label">Alternate Policy Number</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field">
                                            <select required id="update-coverage-priority-dropdown" onChange={(e) => { this.setState({ priority: e.target.value }) }}></select>
                                            <span className="floating-label">Priority(Optional)</span>
                                            <div className="icon-arrow-sm-down update-coverage-arrow-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 coverage-input-field update-coverage-day-picker">
                                            <DayPickerInput
                                                required
                                                value={this.state.startDate || ""}
                                                formatDate={formatDate}
                                                parseDate={parseDate}
                                                placeholder="Effective Date"
                                                onDayChange={(value) => this.setState({ startDate: value })}>
                                            </DayPickerInput>
                                            <div className="icon-calendar-form calendar-icon"></div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <input type="checkbox" className="update-coverage-checkbox" value={this.state.isCourtOrdered ? 1 : 0} onChange={(e) => { this.setState({ isCourtOrdered: !this.state.isCourtOrdered }) }} />
                                            <span className="bold-text">Court Ordered Coverage</span>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <input type="checkbox" className="update-coverage-checkbox" value={this.state.isRetiree ? 1 : 0} onChange={(e) => { this.setState({ isRetiree: !this.state.isRetiree }) }} />
                                            <span className="bold-text">Retiree Policy</span>
                                        </div>
                                    </div>
                                    <div className={`update-coverage-validation-text ${this.state.showValidationError ? "" : "hidden"}`}>
                                        {this.state.validationError}
                                    </div>
                                    <div className="row update-coverage-button-container">
                                        <div className="col-md-6 col-sm-12">
                                            <input type="button" id="update-coverage-cancel-btn" className="btn hp-button" onClick={() => this.props.history.goBack()} value="CANCEL"></input>
                                        </div>
                                            <div className="col-md-6 col-sm-12">
                                                <input type="button" className="btn hp-button" value="SUBMIT" onClick={() => this.submitOtherCoverageRequest()} disabled={this.props.isReadOnly}></input>
                                        </div>
                                    </div>
                                    </div>
                                :
                                    <div id="update-coverage-submitted-message" className="update-other-coverage-container">
                                        <div className={`update-coverage-success-banner ${this.props.error ? "hidden" : ""}`}>
                                            <span className="icon-list-check update-coverage-checkmark"></span>Thanks, your other coverage change has been sent! Your change request number is {this.props.otherCoverageRequestNumber ? this.props.otherCoverageRequestNumber.serviceRequestId : ""}.
                                        </div>
                                        <div className={`update-coverage-failed-banner ${this.props.error ? "" : "hidden"}`}>
                                            Sorry, we cannot submit your request to update other coverage information. If you need assistance, please call 888.000.1234.
                                        </div>
                                        <div className="update-coverage-submit-complete-container">
                                            <div className="update-coverage-button-container">
                                                <input type="button" id="update-coverage-back-button" onClick={() => { this.goToOtherCoveragePage(); }} className="btn update-coverage-submit-button" value="Back to Other Coverage" />
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div> 
                    </div>
                </div>
            </div>
        );
    }

}

const genderOptions = [["M", "Male"], ["F", "Female"]];

const rltpToSubscriberOptions = [["Self", "Self"]
    , ["Spouse", "Spouse"]
    , ["Child", "Child"]
    , ["Other", "Other"]];

const stateOptions = [["ALABAMA", "AL"], ["ALASKA", "AK"], ["AMERICAN SAMOA", "AS"], ["ARIZONA", "AZ"], ["ARKANSAS", "AR"]
    , ["CALIFORNIA", "CA"], ["COLORADO", "CO"], ["CONNECTICUT", "CT"], ["DELAWARE", "DE"], ["DISTRICT OF COLUMBIA", "DC"]
    , ["FLORIDA", "FL"], ["GEORGIA", "GA"], ["GUAM", "GU"], ["HAWAII", "HI"], ["IDAHO", "ID"]
    , ["ILLINOIS", "IL"], ["INDIANA", "IN"], ["IOWA", "IA"], ["KANSAS", "KS"], ["KENTUCKY", "KY"]
    , ["LOUISIANA", "LA"], ["MAINE", "ME"], ["MARYLAND", "MD"], ["MASSACHUSETTS", "MA"], ["MICHIGAN", "MI"]
    , ["MINNESOTA", "MN"], ["MISSISSIPPI", "MS"], ["MISSOURI", "MO"], ["MONTANA", "MT"], ["NEBRASKA", "NE"]
    , ["NEVADA", "NV"], ["NEW HAMPSHIRE", "NH"], ["NEW JERSEY", "NJ"], ["NEW MEXICO", "NM"], ["NEW YORK", "NY"]
    , ["NORTH CAROLINA", "NC"], ["NORTH DAKOTA", "ND"], ["NORTHERN MARIANA IS", "MP"], ["OHIO", "OH"], ["OKLAHOMA", "OK"]
    , ["OREGON", "OR"], ["PENNSYLVANIA", "PA"], ["PUERTO RICO", "PR"], ["RHODE ISLAND", "RI"], ["SOUTH CAROLINA", "SC"]
    , ["SOUTH DAKOTA", "SD"], ["TENNESSEE", "TN"], ["TEXAS", "TX"], ["UTAH", "UT"], ["VERMONT", "VT"], ["VIRGINIA", "VA"]
    , ["VIRGIN ISLANDS", "VI"], ["WASHINGTON", "WA"], ["WEST VIRGINIA", "WV"], ["WISCONSIN", "WI"], ["WYOMING", "WY"]];

const policyTypeOptions = [["Medicare", "Medicare"], ["Non-Medicare", "Non-Medicare"]];

const coverageTypeOptions = [["Medical/PPO","Medical/PPO"]
    , ["Medical/HMO","Medical/HMO"]
    , ["Vision","Vision"]
    , ["Dental", "Dental"]
    , ["Pharmacy", "Pharmacy"]
    , ["No Other Insurance", "No Other Insurance"]];

const priorityOptions = [["Equal Split", "Equal Split"]
    , ["Primary", "Primary"]
    , ["Secondary", "Secondary"]
    , ["Tertiary", "Tertiary"]
    , ["Unknown", "Unknown"]];

const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        otherCoverageRequestNumber: state.healthPlanServices.otherCoverageRequestNumber,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateOtherCoverage: (subName, subBirthDate, subGender, rltpToSub, policyType, mbi, coverageType, planName, altPolicyNum, groupName, groupNumber, priority, isCourtOrdered, isRetiree, companyName, address, address2, city, state, zip, area, phoneNumber, extension, startDate, policyId) => dispatch({
            type: types.HP_UPDATE_OTHER_COVERAGE_START, subName: subName, subBirthDate: subBirthDate, subGender: subGender, rltpToSub: rltpToSub, policyType: policyType, mbi: mbi, coverageType: coverageType,
            planName: planName, altPolicyNum: altPolicyNum, groupName: groupName, groupNumber: groupNumber, priority: priority, isCourtOrdered: isCourtOrdered, isRetiree: isRetiree, companyName: companyName, address: address, address2: address2, city: city, state: state, zip: zip, area: area, phoneNumber: phoneNumber, extension: extension, startDate: startDate, policyId: policyId }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdateOtherCoverage));
